<template>
  <div class="cameras-list-title">
    <div class="cameras-title text"> 
      {{titles.my_cameras}}
    </div>
    <div class="cameras-filter">
      <input v-model="filter_str" type="text" required class="filter-input text" placeholder=" Фільтр">
      <button class="clear-button" type="reset" title="Видалити" @click="filter_reset">&times;</button>
    </div>
    
    <div class="cameras-buttons">
      <img class="button-img" 
        :src="srcs.src_location" 
        @click="click_locationt()" 
      >  
      <img class="button-img" 
        :src="srcs.src_four_list" 
        @click="click_four_list()" 
      >  
      <img class="button-img" 
        :src="srcs.src_six_list" 
        @click="click_six_list()" 
      >  
    </div>
     
  </div>
  <hr class="line">
  <div class="cameras-list" v-if="cliced"> 
    
    <div class="camera-box"   
      v-for="value in filtered_cameras_list" 
      v-bind:key="value.hlsurl"
      >     
      <img class="camera-img" 
        :src="value.imgurl" 
        @click="get_stream(value)"> 
      <div class="camera-descr">
        <div class="text camera-descr-name">{{value.camera_info[0].name}}</div>
        <div class="text camera-descr-geoadr">Розмiщення: {{value.camera_info[0].geoaddr}}</div>
        <div class="text select-camera-checkbox">
          <span class="">Вибрати камеру</span>
          <input type="checkbox" class="check" :value="value" v-model="selected_for_all_cameras_list">
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>

import location from '../assets/images/cameras_list/location.png'
import location_active from '../assets/images/cameras_list/location_active.png'
import four_list from '../assets/images/cameras_list/four_list.png'
import four_list_active from '../assets/images/cameras_list/four_list_active.png'
import six_list from '../assets/images/cameras_list/six_list.png'
import six_list_active from '../assets/images/cameras_list/six_list_active.png'
export default {

  name: "CamerasListComponent",

  props: ['cameras_list' , 'stream_url',],
 
  data () {
    return  {
      titles: {
        my_cameras: 'Мої Камери',
        cameras_plan: 'План Камер'
      },
      menu_images: {
        location_img: {
          id: 0,
          img: location, 
          active_img: location_active,
        },
        four_list_img: {
          id: 1,
          img: four_list, 
          active_img: four_list_active,
        },
        six_list_img: {
          id: 2,
          img: six_list, 
          active_img: six_list_active,
        },
      },

      active_menu: '',

      cliced: true,
      for_check_menu: '',

      srcs: {
        src_location: '',
        src_four_list: '',
        src_six_list: '',
      }, 
      selected_for_all_cameras_list: [],
      filter_str: '',
    }
  },

  created() {
    this.srcs.src_location = this.menu_images.location_img.img
    this.srcs.src_four_list = this.menu_images.four_list_img.img
    this.srcs.src_six_list = this.menu_images.six_list_img.img
  },

  watch: {
    selected_for_all_cameras_list(val) {
      if (this.selected_for_all_cameras_list.length !=0) {
        this.srcs.src_four_list = this.menu_images.four_list_img.active_img
        this.srcs.src_six_list = this.menu_images.six_list_img.active_img
      } else {
        this.srcs.src_four_list = this.menu_images.four_list_img.img
        this.srcs.src_six_list = this.menu_images.six_list_img.img
      }
    },

  },

  computed: {
    filtered_cameras_list() {
      let str = this.filter_str.toLowerCase()     
      return this.cameras_list.filter(elem => {
        if (str === '') return true;
        else return (elem.camera_info[0].name.toLowerCase().indexOf(str)  >- 1 || 
                      elem.camera_info[0].geoaddr.toLowerCase().indexOf(str) >- 1 ||
                      elem.camera_info[0].info.toLowerCase().indexOf(str) >- 1 
                    );
      })
    }
  },

  methods: {
    get_stream (value) {
      event.preventDefault();
      this.stream_url({
        value:value
      })
      window.scrollTo({
      top: 0,
      });
    },


    click_locationt() {  
      this.for_check_menu = 'src_location'
      if (!this.cliced) {
        this.active_buttons('')
      } else {
        this.active_buttons('location')
      }
      this.srcs.src_location = this.menu_images.location_img.active_img
      this.return_cliced()
      this.active_menu = this.menu_images.location_img
      this.active_menu['src'] = 'src_location'
    },

    click_four_list() {
      if (this.selected_for_all_cameras_list.length != 0) {
        sessionStorage.setItem('cameras_list', JSON.stringify(this.selected_for_all_cameras_list))
        sessionStorage.setItem('columns', '2')
        let rou = this.$router.resolve({'name': 'AllCamerasList'})
        window.open(rou.href, '_blank')
      } else {
        this.modal()
        if (this.active_menu['src'] == 'src_location') {
          this.cliced = true   
          this.srcs.src_location = this.menu_images.location_img.img
          this.active_buttons('')
        }
      }
    },

    click_six_list() {
      if (this.selected_for_all_cameras_list.length != 0) {
        sessionStorage.setItem('cameras_list', JSON.stringify(this.selected_for_all_cameras_list))
        sessionStorage.setItem('columns', '3')
        let rou = this.$router.resolve({'name': 'AllCamerasList'})
        window.open(rou.href, '_blank')
      } else {
        this.modal()
        if (this.active_menu['src'] == 'src_location') {
          this.cliced = true   
          this.srcs.src_location = this.menu_images.location_img.img
          this.active_buttons('')
        }
      }
    },

    modal() {
      this.$emit('modal_message', {
        status: 'error',
        title_modal:'Увага',
        text_modal:'Ви не вибрали жодної камери. Будьлавска, виберiть камери.'
      })
      // this.active_buttons('')
      // this.active_buttons('location')
    },

    return_cliced() {
      if ((this.for_check_menu == this.active_menu['src']) || (!this.active_menu['src'])) {
        this.cliced = !this.cliced
        if (this.cliced) {
          for (let a in this.srcs) {
            if (this.active_menu.src == a) {
              this.srcs[a] = this.active_menu.img   
              // this.active_buttons('')     
            }
          }
        }
      } else {
      
        for (let a in this.menu_images) {
          this.cliced = !this.cliced
          if (this.menu_images[a]['id'] === this.active_menu['id']) {
            for (let i in this.srcs) {
              if (this.menu_images[a]['src'] == i ) {
                this.srcs[i] = this.menu_images[a]['img']
                if (this.cliced) {
                  this.cliced = !this.cliced
                }
                
              }
            }
          }
        }
      }
    },
    active_buttons(data) {
      this.$emit('active_button', {
        menu: data
      })
    },

    filter_reset () {
      this.filter_str = ''
    }

  }
};
</script>

<style scoped>

  .camera-img {
    border-radius: 5px 5px 0px  0px;
    height: 133px;
    width: 234px; 
    cursor: pointer;  
  }
  
  .cameras-list-title {
    margin-left: 70px;
    margin-right: 60px;
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 0.6fr 0.6fr;
  }

  .cameras-filter {
    position: relative;
  }

  
  .filter-input {
    width: 90%;
    height: 31px;
    box-sizing: border-box;
    border: 2px solid #C0D72D;
    border-radius: 4px;
    background: #4a4a4a;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    outline: none;
    font-size: 14px;
    color:white;
  }

  .filter-input:focus {
    box-sizing: border-box;
    border: 3px solid #C0D72D;
    border-radius: 5px;
    color:white;
    font-size: 14px;
    line-height: 16px; 
  }

  ::placeholder {
    color:white;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    opacity: 0.5;
  }

  .clear-button {
    position: absolute;
    top: 20%;
    right: 12%;
    border: 0;
    display: none;
    border-radius: 50%;
    background-color: #4a4a4a;
    transition: background 200ms;
    outline: none;
    cursor: pointer;
  }
    
  .clear-button:hover {
    background-color: #848484;
  }

  .filter-input:valid ~ .clear-button {
      display: block;
  }

  .cameras-list {
    margin-left: 50px;
    margin-right: 50px;
    margin-top: 30px;
    margin-bottom: 50px;
    display: grid;
    justify-items: center;
    justify-content: center;
    gap: 25px;
    grid-template-columns: repeat(auto-fit, minmax(235px, 230px));
  }

  .cameras-title {
    font-weight: bold;
    font-size: 24px;
  }

  .cameras-buttons {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 25px;

  }

  .button-img {
    cursor: pointer;
  }

  hr {
    width: 212px;
    border: 1px solid #D6D6D6;
    margin-left: 0;
  }

  .camera-box {
    background: #383838;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
  }

  .camera-descr {
    margin-left: 2px;
    margin-bottom: 2px;
  }

  .camera-descr-name{
    font-size: 14px;
    font-weight: bold;
  }
  .camera-descr-geoadr {
    font-size: 14px;
  }

  .select-camera-checkbox {
    text-align: right;
    font-size: 16px;
  }

  span {
    margin-bottom: 123px;
  }

  .check {
    width: 12px;
    height: 12px;
    margin-right: 5px;
    cursor: pointer;
  }

  .check:after {
    background-color: #C0D72D;
    display: inline-block;
    visibility: visible;
    width: 12px;
    height: 13px;
    border-radius: 3px;
  }

  .check:checked:after {
     content: "\2714";
  }

  @media (max-width: 700px) {

    hr {
      width: 145px;
    }

    .cameras-title {
      font-size: 20px;
    }

    .cameras-list-title {
      margin-left: 30px;
      margin-right: 30px;
    }

    .camera-img {
      height: auto;
      width: 100%;
    }

    .cameras-list {
      margin-bottom: 30px;
      grid-template-columns: repeat(auto-fit, minmax(195px, auto));
    }
    
  }

  @media (max-width: 600px) {
  
    .cameras-title {
       font-size: 14px;
     }

    .cameras-list-title {
      margin-left: 20px;
      margin-right: 20px;
      grid-template-columns: 0.5fr 0.5fr 0.7fr;
    }

    .filter-input {
    height: 22px;
    }

    ::placeholder {
      color:white;
      font-size: 12px;
    }

    .cameras-filter .clear-button[type="reset"] { 
      top: 13%;
    }

    .button-img {
      height: auto;
      width: 80%;
    }

    .cameras-buttons {
      gap: 20px;
    }

    hr {
      width: 115px;
    }

    .camera-img {
      height: auto;
      width: 100%;
    }
    .cameras-list {
      margin-left: 20px;
      margin-right: 20px;
      grid-template-columns: repeat(auto-fit, minmax(175px, auto));
    }

  }

  @media (max-width: 450px) {

    .cameras-list {
      margin-left: 40px;
      margin-right: 40px;
      gap: 10px;
    }
    .camera-box {
      height: auto;
      width: 70%;
      cursor: pointer;
    }

    .button-img {
      width: 100%;
    }


  }

</style>

